import type React from 'react';

import type { OverridableComponent } from '@mui/material/OverridableComponent';
import type { SvgIconTypeMap } from '@mui/material/SvgIcon/SvgIcon';

import type ColormapInterface from 'shared-types/colormapinterface';

import { ButtonContainer, StyledButton } from './ControlButton.style';

interface Props {
  Icon: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  large?: boolean;
  id?: string;
  colors: ColormapInterface;
  playPlauseButton?: boolean;
}

const ControlButton: React.FC<Props> = ({ Icon, playPlauseButton, disabled, ...buttonProps }) => {

  return (
    <ButtonContainer>
      <StyledButton playPlauseButton={!!playPlauseButton} disabled={disabled} {...buttonProps}>
        <Icon fontSize='inherit' />
      </StyledButton>
    </ButtonContainer>
  );
};
export default ControlButton;
